











import { Vue, Component, Prop } from 'vue-property-decorator'
import Card from '../Card.vue'
import Scale from './Scale.vue'
import { IScale } from '../../../types/interfaces'

@Component({
  components: {
    Scale,
    Card
  }
})
export default class ScaleCard extends Vue {
  @Prop({ required: true }) scale!: IScale
  @Prop({ required: true }) name!: string
  @Prop({ required: true }) labelText!: string

  passThroughInput (input: string) {
    this.$emit('input', this.name, input)
  }
}
